import { deleteHandbookURL, getHandbooksWithPaginationURL } from "@app/constants/ApiEndPoints";
import axios from "axios";

export const getHandbooksWithPagination = async (page, perPage, sortField, sortDirection, search) => {
	try {
		const response = await axios.get(getHandbooksWithPaginationURL + `?page=${page}&perPage=${perPage}&sortField=${sortField}&sortDirection=${sortDirection}&name=${search.name}
		&description=${search.description}&subjectId=${search.subjectId}&moduleId=${search.moduleId}&price=${search.price}&status=${search.status}`);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const deleteHandbookById = async (id: number) => {
	try {
		const response = await axios.delete(deleteHandbookURL + id);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data;
		}
		return response?.data;
	} catch (error) {
		return error?.response?.data;
	}
};